// Bottom bar menu icons

const iconLibrary = {
  // NavBar icons
  bills: 'iconA-factura-nuevo-2',
  offers: 'iconA-ofertas',
  myData: 'iconA-usuario',
  breakdown: 'iconA-soporte-tecnico',
  breakdownSolid: 'iconA-ICO-AJUSTES',
  myProducts: 'iconA-dispositivos',
  product: 'iconA-producto',
  // Header Icons
  bell: 'iconA-campana-whiteoff',
  help: 'iconA-interrogante',
  atPriority: 'iconA-at-priority',
  chat: 'iconA-chat-nuevo',
  mail: 'iconA-email',
  logoMovistar: 'iconA-m-nuevo',
  // My products Icons
  tele: 'iconA-tv-medio',
  teleSolid: 'iconA-ICO-TV',
  internet: 'iconA-fibra',
  fijo: 'iconA-fijo-medio',
  movil: 'iconA-movil-medio',
  movilSolid: 'iconA-movil-solid',
  internetSolid: 'iconA-internet-solid',

  // Auxiliar icons
  rightChevron: 'iconA-cheuron-dcha',
  leftChevron: 'iconA-cheuron-izq',
  downChevron: 'iconA-cheuron-down',
  upChevron: 'iconA-cheuron-up',
  download: 'iconA-descargar-nuevo',
  ballContainer: 'iconA-contenedor',
  close: 'iconA-close',
  callIn: 'iconA-flecha-abajo',
  callOut: 'iconA-flecha-arriba',
  ok: 'iconA-v',
  atCliente: 'iconA-at-cliente',
  // Help Icons
  searchIcon: 'iconA-lupa-medio',
  informationIcon: 'iconA-info',
  // others
  clock: 'iconA-reloj',
  shutdown: 'iconA-on',
  error: 'iconA-error',
  correcto: 'iconA-correcto',
  sms: 'iconA-sms',
  smsSolid: 'iconA-ICO-SMS',
  seguridad: 'iconA-seguridad',
  alert: 'iconA-alert',
  // Internet
  modemSettingUp: 'iconA-configuracion-modem',
  internetHelperAsistance: 'iconA-servicio-tecnico-internet-ico',
  upload: 'iconA-subida-nuevo',
  // TV Icons
  canales80: 'iconA-80canales-medium',
  tvSeleccion: 'iconA-mastv-medium',
  movistarPlus: 'movistar-plus',
  alacarta: 'iconA-alacarta',
  asiatico: 'iconA-asiatico',
  cine: 'iconA-cine',
  deportes: 'iconA-deportes',
  familiar: 'iconA-familiar',
  series: 'iconA-series',
  premium: 'iconA-premium',
  motor: 'iconA-motor',
  latino: 'iconA-latino',
  infantil: 'iconA-infantil',
  futbol: 'iconA-futbol',
  ficcion: 'iconA-ficcion',
  toros: 'iconA-toros',
  netflix: 'iconA-netflix-medium',
  disney: 'iconA-disney-medium',
  /* shipping orders */
  shipping: 'iconA-envio-medium',
  fusion: 'iconA-fusion-sp',
  settings: 'iconA-configuracion-solid',
  cart: 'iconA-carrito-solid',
  building: 'location_city',
  euro: 'euro_symbol',
  hourglass: 'hourglass_full',
  exclamation: 'iconA-aviso-sp',
  /* sva */
  movistarcar: 'iconA-icon-movcar-white',
  movistarcloud: 'iconA-icon-cloud-white-logo-ok',
  /* prepay */
  card: 'iconA-tarjeta',
  calendar: 'iconA-calendario-medium',
  currency: 'iconA-dinero-medium',
  factura: 'iconA-ico-factura',

  /* novum */
  soporteAutodiagnostico: 'iconA-soporte-novum',

  /* soteira */
  soteira: 'iconA-soteira',
  soteira2: 'iconA-soteira2',

  /* qustodio */
  qustodio: 'iconA-qustodio',
  qustodio2: 'iconA-qustodio2',

  /* TOKENIZACIÓN */
  masGB: 'iconA-mas-gb',
  film: 'iconA-film', // Play
  alertNovum: 'iconA-alert-novum', // Alerta
  okNovum: 'iconA-ok-novum', // Ok
  infoNovum: 'iconA-info-novum', // Informacion
  infinitosGB: 'iconA-infinitos-gb',
  degustacionTV: 'iconA-empty', // Tv

  /* DISNEY */
  disneyTv: 'iconA-disneyTV',

  /* 2º GLYPHTER */
  contratos: 'iconB-contratos',
  descarga: 'iconB-descarga',
  ecologico: 'iconB-ecologico',

  /* ehealth */
  ehealth: 'MeGusta',
};

export default iconLibrary;
